// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file purchase_return/list_credit_notes.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { CreditNoteInfo } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.ListCreditNotesRequest
 */
export class ListCreditNotesRequest extends Message<ListCreditNotesRequest> {
  /**
   * ID of the supplier for whom to list credit notes
   *
   * @generated from field: string supplier_id = 1;
   */
  supplierId = "";

  /**
   * Page number for pagination
   *
   * @generated from field: int32 page = 2;
   */
  page = 0;

  /**
   * Number of records per page
   *
   * @generated from field: int32 page_size = 3;
   */
  pageSize = 0;

  /**
   * Whether to include fully used credit notes in the response
   *
   * @generated from field: bool include_fully_used = 4;
   */
  includeFullyUsed = false;

  constructor(data?: PartialMessage<ListCreditNotesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListCreditNotesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "supplier_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "include_fully_used", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCreditNotesRequest {
    return new ListCreditNotesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCreditNotesRequest {
    return new ListCreditNotesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCreditNotesRequest {
    return new ListCreditNotesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListCreditNotesRequest | PlainMessage<ListCreditNotesRequest> | undefined, b: ListCreditNotesRequest | PlainMessage<ListCreditNotesRequest> | undefined): boolean {
    return proto3.util.equals(ListCreditNotesRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ListCreditNotesResponse
 */
export class ListCreditNotesResponse extends Message<ListCreditNotesResponse> {
  /**
   * List of credit notes
   *
   * @generated from field: repeated com.neulink.pharmacy.CreditNoteInfo credit_notes = 1;
   */
  creditNotes: CreditNoteInfo[] = [];

  /**
   * Total number of credit notes available
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<ListCreditNotesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListCreditNotesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "credit_notes", kind: "message", T: CreditNoteInfo, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCreditNotesResponse {
    return new ListCreditNotesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCreditNotesResponse {
    return new ListCreditNotesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCreditNotesResponse {
    return new ListCreditNotesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListCreditNotesResponse | PlainMessage<ListCreditNotesResponse> | undefined, b: ListCreditNotesResponse | PlainMessage<ListCreditNotesResponse> | undefined): boolean {
    return proto3.util.equals(ListCreditNotesResponse, a, b);
  }
}

